module.exports = __webpack_public_path__ + "img/MEDIA099.9814be56.jpg";